import React from 'react';

import classes from 'classnames';
import { useSelector } from 'react-redux';

import baseStyles from 'components/shared/FormAdapters/FormDefault/Input/index.module.css';
import Label from 'components/shared/FormAdapters/FormDefault/Label';
import Icon from 'components/shared/Icon';
import ArrowUp from 'components/shared/Icon/icons/ArrowUp';
import { brandingSelector } from 'store/user/selectors';

import { REPLACE_REMOVE_LOGO_PLACEHOLDER, UPLOAD_LOGO_PLACEHOLDER } from '../constants';
import styles from './index.module.css';

const Button = ({ onClick }) => {
  const { logo } = useSelector(brandingSelector);

  const inputContainerClasses = classes(baseStyles.inputContainer, styles.inputContainer);
  const inputClasses = classes(baseStyles.input, styles.label);

  const formGroupClasses = classes(styles.formGroup);

  return (
    <div className={formGroupClasses} onClick={onClick}>
      <Label className={styles.formLabel}>Logo</Label>
      <div className={inputContainerClasses}>
        <input className={styles.fileInput} />
        <label className={inputClasses}>
          <div className={styles.arrowButton}>
            {logo ? (
              <img className={styles.img} src={logo.url} alt="logo" />
            ) : (
              <Icon component={ArrowUp} width="1.5rem" />
            )}
          </div>
          <span className={styles.placeholder}>{logo ? REPLACE_REMOVE_LOGO_PLACEHOLDER : UPLOAD_LOGO_PLACEHOLDER}</span>
        </label>
      </div>
    </div>
  );
};

export default Button;
